'use client'

import {Slider as AntSlider} from 'antd'
import {SliderRangeProps} from 'antd/es/slider'
import styled from 'styled-components'
import theme from "@/src/config/theme";

const SliderStyled = styled(AntSlider)`
  & .ant-slider-handle,
  &.ant-slider:hover .ant-slider-handle,
  &.ant-slider:focus .ant-slider-handle,
  &.ant-slider:active .ant-slider-handle,
  &.ant-slider:focus-within .ant-slider-handle {
    &::before {
      border-color: ${theme.colors.dark} !important;
    }

    &::after {
      border-radius: 0;
      box-shadow: 0 0 0 2px ${theme.colors.dark};
      background: ${theme.colors.dark};
    }
  }
`

const Slider = (props: Omit<SliderRangeProps, 'range'>) => {
  return <SliderStyled range {...props} />
}

export default Slider
